<!--  -->
<template>
  <div class='selectCategory'>
    <el-dialog title="选择供方分类"
            width="40%"
            :close-on-click-modal="$root.dialogAutoClose"
            :close-on-press-escape="$root.dialogAutoClose"
            :visible.sync="treeDialog">
        <div style="max-height: 500px;overflow-y: auto;">
            <el-tree :data="treeData"
                    :check-strictly="true"
                    :props="$root.treeProps"
                    highlight-current
                    :expand-on-click-node="false"
                    :show-checkbox="true"
                    :default-checked-keys="defaultCheckedKeys"
                    node-key="id"
                    ref="categoryTree"
                    @check-change="handleCheckChange"
                    @node-click="nodeClick"></el-tree>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="treeDialog = false">取 消</el-button>
            <el-button type="primary" @click="treeConfirm">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.component('select-category', {
//import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
        //供方分类
        categoryTreeList: [],
        categoryTreeListCopy: [],
        treeDialog: false,
        treeData: [],
        defaultCheckedKeys: [],

        checkedId: '',
        selectedSupplierCategorys: [],
    }
  },
//方法集合
  methods: {
    handleCheckChange(data, checked, node){
        if(checked == true){
          this.checkedId = data.id;
          this.$refs.categoryTree.setCheckedNodes([data]);
        }
    },
    nodeClick(data,checked,node){
        if(data.categoryLevel == 3){
          this.checkedId = data.id
          this.$refs.categoryTree.setCheckedNodes([data]);
        }
    },
    //获取供方分类完整树形数据
    getTreeList(){
        let that = this;
        that.$root.postHttp('/v1/sSuppliersCategory/public/findSuppliersCategoryTreeList',{
            "categoryStatus": '',
            "pageFlag": 0,
            "pageNumber": 0,
            "pageSize": 0
        },function (res) {
            that.categoryTreeList = res.data.data.tree;
        });
    },
    show(){
      this.treeDialog = true;
      this.treeData = this.categoryTreeList;
    },
    treeConfirm(){
      let that = this;
      let selectedData = that.$refs['categoryTree'].getCheckedNodes(true);

      that.selectedSupplierCategorys = selectedData;
      if(this.selectedSupplierCategorys.length==0){
          this.$alert('请选择供方分类！',{
              type:'warning'
          });
          return;
      }

      that.$emit("callback", that.selectedSupplierCategorys[0]);
      that.treeDialog = false;
  },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getTreeList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

},
})
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.selectCategory /deep/{
  .el-tree-node{
      .is-leaf + .el-checkbox .el-checkbox__inner{
          display: inline-block;
      }
      .el-checkbox .el-checkbox__inner{
          display: none;
      }

      .el-checkbox__input.is-disabled {
        .el-checkbox__inner {
          cursor: default;
        }
      }
  }
}
        

</style>


// WEBPACK FOOTER //
// src/components/SelectCategory.vue